"use client";

/**
 * AdminLayout 내부에서 사이드바/헤더가 공유하는 상태 컨텍스트.
 *
 * - collapsed: 데스크탑 사이드바 접힘(아이콘 전용) 여부
 * - mobileOpen: 모바일 Drawer(Sheet) 열림 여부
 * - isMobile: 현재 모바일 뷰포트 여부
 *
 * 직접 사용하기보다 useAdminLayout() 훅으로 접근한다.
 */
import { type ReactNode, createContext, useContext } from "react";

interface AdminLayoutContextValue {
  collapsed: boolean;
  setCollapsed: (v: boolean) => void;
  toggleCollapsed: () => void;
  mobileOpen: boolean;
  setMobileOpen: (v: boolean) => void;
  isMobile: boolean;
}

const AdminLayoutContext = createContext<AdminLayoutContextValue | null>(
  null
);

export function useAdminLayout() {
  const ctx = useContext(AdminLayoutContext);
  if (!ctx) {
    throw new Error("useAdminLayout 은 <AdminLayout> 내부에서만 사용할 수 있습니다.");
  }
  return ctx;
}

export function AdminLayoutProvider({
  value,
  children,
}: {
  value: AdminLayoutContextValue;
  children: ReactNode;
}) {
  return (
    <AdminLayoutContext.Provider value={value}>
      {children}
    </AdminLayoutContext.Provider>
  );
}
